import { render, staticRenderFns } from "./teleconsultation.vue?vue&type=template&id=88cb7cb8&"
import script from "./teleconsultation.vue?vue&type=script&lang=js&"
export * from "./teleconsultation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports